import {
  AwsIconUrl,
  AwsRdsIconUrl,
  AzureIconUrl,
  CiscoIconUrl,
  CustomIconUrl,
  EntraIdIconUrl,
  GcloudIconUrl,
  GithubIconUrl,
  GoogleWorkspaceIconUrl,
  IncidentIoIconUrl,
  K8sIconUrl,
  McpIconUrl,
  MysqlIconUrl,
  OktaIconUrl,
  OracleIconUrl,
  PagerdutyIconUrl,
  PostgresIconUrl,
  RdpIconUrl,
  SelfHostedIconUrl,
  SnowflakeIconUrl,
  SplunkIconUrl,
  SshIconUrl,
  TailscaleIconUrl,
  WindowsIconUrl,
  ZscalerIconUrl,
} from "@p0security/shared/integrations/constants";
import { ReactNode } from "react";

import { Logo } from "./Logo";

export const PermissionIntegrationLogo: Record<string, ReactNode> = {
  aws: <Logo logo={AwsIconUrl} title="AWS" />,
  "aws-rds": <Logo logo={AwsRdsIconUrl} title="AWS RDS" />,
  azure: <Logo logo={AzureIconUrl} title="Azure" />,
  "azure-ad": <Logo logo={EntraIdIconUrl} title="Entra ID (Legacy)" />,
  "entra-id": <Logo logo={EntraIdIconUrl} title="Entra ID" />,
  "cisco-secure-access": (
    <Logo logo={CiscoIconUrl} title="Cisco Secure Access" />
  ),
  custom: <Logo logo={CustomIconUrl} title="Custom" />,
  gcloud: <Logo logo={GcloudIconUrl} title="Google Cloud" />,
  github: <Logo logo={GithubIconUrl} title="GitHub" />,
  k8s: <Logo logo={K8sIconUrl} title="Kubernetes" />,
  mcp: <Logo logo={McpIconUrl} title="MCP gateway" />,
  mysql: <Logo logo={MysqlIconUrl} title="MySQL" />,
  snowflake: <Logo logo={SnowflakeIconUrl} title="Snowflake" />,
  "splunk-stack": <Logo logo={SplunkIconUrl} title="Splunk Stack Access" />,
  okta: <Logo logo={OktaIconUrl} title="Okta" />,
  oci: <Logo logo={OracleIconUrl} title="Oracle Cloud" />,
  pg: <Logo logo={PostgresIconUrl} title="PostgreSQL" />,
  rdp: <Logo logo={RdpIconUrl} title="RDP" />,
  ssh: <Logo logo={SshIconUrl} title="SSH" />,
  tailscale: <Logo logo={TailscaleIconUrl} title="Tailscale" />,
  windows: <Logo logo={WindowsIconUrl} title="Windows" />,
  workspace: <Logo logo={GoogleWorkspaceIconUrl} title="Google Workspace" />,
  "self-hosted": <Logo logo={SelfHostedIconUrl} title="Self-hosted" />,
  "zscaler-private-access": (
    <Logo logo={ZscalerIconUrl} title="Zscaler Private Access" />
  ),
};

export const hasLogo = (
  key: string
): key is keyof typeof PermissionIntegrationLogo =>
  key in PermissionIntegrationLogo;

export const AllIntegrationLogos = {
  ...PermissionIntegrationLogo,
  pagerduty: <Logo logo={PagerdutyIconUrl} title="PagerDuty" />,
  incidentio: <Logo logo={IncidentIoIconUrl} title="Incident.io" />,
};
